import { render, staticRenderFns } from "./SingSynchroPreview.vue?vue&type=template&id=5f172183&scoped=true"
import script from "./SingSynchroPreview.vue?vue&type=script&lang=js"
export * from "./SingSynchroPreview.vue?vue&type=script&lang=js"
import style0 from "./SingSynchroPreview.vue?vue&type=style&index=0&id=5f172183&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f172183",
  null
  
)

export default component.exports